import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import Spinner from "../../primitives/Spinner/Spinner";
import css from "./PageLoader.module.css";

const PageLoader = React.forwardRef(
  ({ label = "Loading…", className, ...rest }, ref) => (
    <div
      ref={ref}
      role="status"
      className={clsx(css.root, className)}
      {...rest}
    >
      <Spinner size="lg" label="" className={css.spinner} aria-hidden="true" />
      <span className={css.label}>{label}</span>
    </div>
  ),
);

PageLoader.displayName = "PageLoader";

PageLoader.propTypes = {
  label: PropTypes.string,
  className: PropTypes.string,
};

export default PageLoader;
